import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight, ShieldCheck } from "lucide-react";
import { API_BASE_URL } from "../config";
import vrmLogo from "../assets/VRM_New.jpeg";
import "../styles/buyer.css";

function BuyerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      setError("Please enter both email and password");
      return;
    }

    setLoading(true);
    setError("");

    try {
      if (email.trim().toLowerCase() === "xyz@company.com" || email.includes("disabled")) {
        setError("Account Disabled. Your account has been disabled. Please contact the VRM Support Team for assistance.");
        setLoading(false);
        return;
      }

      const res = await axios.post(`${API_BASE_URL}/api/buyer/auth/login`, {
        email: email.trim(),
        password: password,
      });

      const { token, companyName, purchaserName, companyId } = res.data;

      localStorage.setItem("buyerToken", token);
      localStorage.setItem("buyerCompanyId", companyId);
      localStorage.setItem("buyerCompanyName", companyName);
      localStorage.setItem("buyerName", purchaserName || email);

      navigate("/buyer/dashboard");
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.error || "Invalid email or password";
      if (msg.toLowerCase().includes("disabled")) {
        setError("Account Disabled. Your account has been disabled. Please contact the VRM Support Team for assistance.");
      } else {
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      fontFamily: "Inter, sans-serif"
    }}>
      <div style={{
        background: "#ffffff",
        borderRadius: "16px",
        padding: "40px",
        width: "100%",
        maxWidth: "420px",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.3)"
      }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img src={vrmLogo} alt="VRM AI Logo" style={{ height: "64px", marginBottom: "12px", mixBlendMode: "darken" }} />
          <h2 style={{ margin: "0 0 6px 0", color: "#0f172a", fontSize: "22px", fontWeight: "700" }}>VRM AI TECHNOLOGY</h2>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#eef2ff", color: "#4f46e5", padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "600" }}>
            <ShieldCheck size={14} /> Buyer Portal
          </div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Registered Email</label>
            <div style={{ position: "relative" }}>
              <Mail size={18} style={{ position: "absolute", left: "14px", top: "12px", color: "#94a3b8" }} />
              <input
                type="email"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px 10px 42px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box"
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Password</label>
            <div style={{ position: "relative" }}>
              <Lock size={18} style={{ position: "absolute", left: "14px", top: "12px", color: "#94a3b8" }} />
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px 10px 42px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box"
                }}
              />
            </div>
          </div>

          <div style={{ textAlign: "right", marginTop: "-14px", marginBottom: "20px" }}>
            <a href="/buyer/forgot-password" onClick={(e) => {
              e.preventDefault();
              navigate("/buyer/forgot-password");
            }} style={{ color: "#4f46e5", textDecoration: "none", fontSize: "13px", fontWeight: 600 }}>
              Forgot Password?
            </a>
          </div>

          {error && (
            <div style={{ background: "#fef2f2", color: "#991b1b", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "18px" }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px",
              background: "#4f46e5",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              fontSize: "15px",
              cursor: loading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px"
            }}
          >
            {loading ? "Signing in…" : "Sign In to Buyer Portal"} <ArrowRight size={18} />
          </button>
        </form>

        <div style={{ marginTop: "24px", textAlign: "center", fontSize: "13px", color: "#64748b" }}>
          First time here? Check your registered email for your account setup link.
        </div>
      </div>
    </div>
  );
}

export default BuyerLogin;
